import { create } from 'zustand'
import { User } from '@/types/user'
import usersAPI from '@/services/api/users'
import { SESSION_TOKEN } from '@/utils/constants'
import i18n from '@/i18n'

interface UserState {
  user: User | null
  isLoading: boolean
  error: string | null
  sync: () => Promise<User | null>
  setUser: (user: User | null) => void
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  isLoading: true,
  error: null,

  sync: async () => {
    set({ isLoading: true, error: null })
    const token = localStorage.getItem(SESSION_TOKEN)

    if (!token) {
      set({ user: null, isLoading: false })
      return null
    }

    const { status, data } = await usersAPI.show()

    if (status === 401) {
      localStorage.removeItem(SESSION_TOKEN)

      set({
        user: null,
        isLoading: false,
        error: i18n.t('validation.failedToAuthenticate') as string
      })

      return null
    } else if (status === 200) {
      set({ user: data.user, isLoading: false })
      return data.user
    }

    set({ isLoading: false })
    return null
  },

  setUser: (user) => set({ user })
}))